module.exports = "<p>\n  pac-solicitud-aprobar works!\n</p>\n"